/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_App_NameInputs */



/**
* | output |
* | --- |
* | "Application Name" |
*
* @param {Developer_App_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_app_name = /** @type {((inputs?: Developer_App_NameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_App_NameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de l'application")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la aplicación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome do Aplicativo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome Applicazione")
	return /** @type {LocalizedString} */ ("Application Name")
});